import React, { Component } from "react";
import Swiper from "react-id-swiper";
import { observer } from "mobx-react";
import Project from "./Project";
import "./Home.css";
import logoSrc from "../assets/images/reaktivate_logo_original.svg"

@observer
class Home extends Component {
  constructor(props) {
    super(props);
    this.swiper = null;
    this.state = {
      showHint: true
    };
  }

  componentWillMount() {
    this.setState({ current_slide: window.CURRENT_SLIDE ? parseInt(window.CURRENT_SLIDE, 10) : 0 });
  }

  render() {
    const self = this;
    const initialSlide = this.state.current_slide;
    const { showHint } = this.state;
    const { projects } = this.props;
    const project = self.swiper ? projects[self.swiper.activeIndex] : projects[initialSlide];
    const params = {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      speed: 700,
      mousewheel: {
        forceToAxis: false,
        invert: false,
        sensitivity: 0.5
      },
      grabCursor: true,
      shouldSwiperUpdate: false,
      rebuildOnUpdate: false,
      centeredSlides: true,
      slidesPerView: "auto",
      watchSlidesProgress: true,
      initialSlide: initialSlide,
      on: {
        transitionStart: e => {
          if (self.swiper) {
            if (showHint) {
              self.setState({ showHint: false });
            }
            const progress = self.swiper.forward ? "progress-right" : "progress-left";

            self.swiper.$el[0].className =
              "swiper-container swiper-container-horizontal " + progress;
            self.bg.className = "background-new progress";
          }
        },
        transitionEnd: () => {
          if (self.swiper) {
            self.swiper.$el[0].className = "swiper-container swiper-container-horizontal";
            self.swiper.isSwiping = false;
            self.bg.className = "background-new";
          }
        }
      }
    };

    return (
      <div className="Home">
        <Swiper
          {...params}
          ref={node => {
            if (node) this.swiper = node.swiper;
          }}
        >
          {projects.map((object, index) => (
            <div key={object.slug}>
              <Project project={object} key={object.slug} index={index} />
            </div>
          ))}
        </Swiper>
        <div
          ref={node => {
            if (node) this.bg = node;
          }}
          className="background-new"
        >
          <div
            style={{
              backgroundImage: `url('${
                project
                  ? project.mainImage
                  : logoSrc
              }')`,
              backgroundSize: `${project ? "cover" : "220px"}`
            }}
          />
          <svg width="100%" height="100%" version="1.1">
            <circle
              className="svg-circle"
              cx="50%"
              cy="50%"
              r="50%"
              style={{ fill: "none", strokeWidth: "1px", stroke: "#D8D8D8" }}
            />
          </svg>
        </div>
        {showHint && <div className="swiper-hint">Scroll to discover..</div>}
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js